/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayIcon64Regular = forwardRef('MediaUiAPlayIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 12.327c0-4.352 4.814-6.98 8.474-4.627l30.603 19.673c3.368 2.165 3.368 7.088 0 9.253L22.474 56.3C18.814 58.653 14 56.025 14 51.673V12.327Zm6.852-2.103C19.188 9.154 17 10.349 17 12.327v39.346c0 1.978 2.188 3.173 3.852 2.103l30.603-19.673c1.53-.984 1.53-3.222 0-4.206L20.852 10.224Z" })));
});
